import { Dispatch, ReactElement, SetStateAction, createContext, useState } from 'react';
import { MinimalTarget, PlutoPerson } from '@/generated/model';
import { ReportTabs, ReportTabValue } from '@/types';

export type ReportContextType = {
  tab: ReportTabValue;
  setTab: Dispatch<SetStateAction<ReportTabValue>>;
  lastVisitedTab: ReportTabs;
  setLastVisitedTab: Dispatch<SetStateAction<ReportTabs>>;
  selectedTargets: MinimalTarget[];
  setSelectedTargets: Dispatch<SetStateAction<MinimalTarget[]>>;
  selectedDates: { from: Date; to: Date } | undefined;
  setSelectedDates: Dispatch<SetStateAction<{ from: Date; to: Date } | undefined>>;
  searchText: string | undefined;
  setSearchText: Dispatch<SetStateAction<string | undefined>>;
  driverSearchText: string | undefined;
  setDriverSearchText: Dispatch<SetStateAction<string | undefined>>;
  selectedTemplateIds: number[];
  setSelectedTemplateIds: Dispatch<SetStateAction<number[]>>;
  addressee: string | undefined;
  setAddressee: Dispatch<SetStateAction<string | undefined>>;
  selectedDrivers: PlutoPerson[];
  setSelectedDrivers: Dispatch<SetStateAction<PlutoPerson[]>>;
  maxTargetNumber: number;
  setMaxTargetNumber: Dispatch<SetStateAction<number>>;
  showDeactivated: boolean;
  setShowDeactivated: Dispatch<SetStateAction<boolean>>;
};

export const ctxReport = createContext<ReportContextType | undefined>(undefined);

export function ReportContext({ children }: { children: ReactElement }) {
  const [tab, setTab] = useState<ReportTabValue>(ReportTabValue.dateSelect);
  const [lastVisitedTab, setLastVisitedTab] = useState<ReportTabs>('TargetTab');
  const [selectedTargets, setSelectedTargets] = useState<MinimalTarget[]>([]);
  const [selectedDates, setSelectedDates] = useState<{ from: Date; to: Date } | undefined>(undefined);
  const [searchText, setSearchText] = useState<string | undefined>(undefined);
  const [driverSearchText, setDriverSearchText] = useState<string | undefined>(undefined);
  const [selectedTemplateIds, setSelectedTemplateIds] = useState<number[]>([]);
  const [addressee, setAddressee] = useState<string | undefined>(undefined);
  const [selectedDrivers, setSelectedDrivers] = useState<PlutoPerson[]>([]);
  const [maxTargetNumber, setMaxTargetNumber] = useState<number>(0);
  const [showDeactivated, setShowDeactivated] = useState<boolean>(false);

  return (
    <ctxReport.Provider
      value={{
        tab,
        setTab,
        lastVisitedTab,
        setLastVisitedTab,
        selectedTargets,
        setSelectedTargets,
        selectedDates,
        setSelectedDates,
        searchText,
        setSearchText,
        driverSearchText,
        setDriverSearchText,
        selectedTemplateIds,
        setSelectedTemplateIds,
        addressee,
        setAddressee,
        selectedDrivers,
        setSelectedDrivers,
        maxTargetNumber,
        setMaxTargetNumber,
        showDeactivated,
        setShowDeactivated,
      }}
    >
      {children}
    </ctxReport.Provider>
  );
}
